import React from 'react';
import {connect} from 'react-redux';
import {actions, selectors} from '../../Redux/index';

/**
 * This is basically a link for toggling the locale.
 */
const LanguageSelector = (props) => {
    let otherLanguageLabel = props.locale === 'de' ? "English" : "Deutsch";
    const handleClick = (e) => {
        e.preventDefault(); // Prevent navigation
        e.stopPropagation(); // Stop event from bubbling up
        props.onLanguageClick(props.locale);
    };

    return (
        // Use a span with button role instead of a Link to prevent URL changes
        <span role="button" tabIndex="0" onClick={handleClick} onKeyDown={(e) => e.key === 'Enter' && handleClick(e)} style={{cursor: 'pointer'}}>
            {otherLanguageLabel}
        </span>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLanguageClick: (language) => {
            dispatch(actions.UI.Locale.changeLanguage(language === 'de' ? 'en' : 'de'))
        }
    }
};

const mapStateToProps = (state) => {
    return {
        locale: selectors.UI.Locale.getLocale(state)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);